export default {
  devices: []
};



// WEBPACK FOOTER //
// webpack://grapesjs/src/device_manager/config/config.js